import * as React from "react";
import { useSiteMetadata } from "../hooks/use-site-metadata";

export const SEO = (props: { pathname: string }) => {
  const { title, description, siteUrl } = useSiteMetadata();

  const seo = {
    title,
    description,
    url: `${siteUrl}${props.pathname}`,
  };

  return (
    <>
      <title>{seo.title}</title>
      <meta name="og:title" content={seo.title} />
      <meta name="description" content={seo.description} />
      <meta name="og:description" content={seo.description} />
      <meta name="og:url" content={seo.url} />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org/",
          "@type": "ProfilePage",
          dateCreated: "2024-06-15T11:50:00+0800",
          dateModified: "2024-06-15T11:50:00+0800",
          mainEntity: {
            "@type": "Person",
            name: "Lee Yen Ter",
            givenName: "Yen Ter",
            url: "https://leeyenter.com",
            sameAs: ["https://linkedin.com/in/yenter/"],
            description:
              "Full-Stack Software Engineer | AI/ML & Data Science Expert | Agile & XP Practitioner | Public Speaker & Mentor | Founder & CEO",
          },
        })}
      </script>
      <html lang="en" />
    </>
  );
};
